export const getTopLevelGroup = (topLevelGroups: { [key: string]: string[] }, groupKey: string): string | undefined => {
	const topLevelGroup: string | undefined = topLevelGroups
		? Object.keys(topLevelGroups).find((topLevelGroup: string) => topLevelGroups![topLevelGroup].includes(groupKey))
		: undefined;
	return topLevelGroup;
};
